import styled from "styled-components";

export const SvgIcon = styled.span`
    & > svg {
        & > path {
            fill: ${props => props.svgIconColor}
        }
    }
`;